<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="90"
    height="90"
    viewBox="0 0 90 90"
    aria-labelledby="palette"
    role="presentation">
    <g id="palette">
      <circle cx="45" cy="45" r="43"
        stroke="#83949b" stroke-width="2" fill="none" />
      <circle cx="45" cy="45" r="43"
        stroke="#0097de" stroke-width="2" fill="none"
        :stroke-dasharray="start">
        <animate ref="animate" attributeName="stroke-dasharray"
          :from="start"
          :to="end"
          begin="indefinite"
          dur="2.4s"/>
      </circle>
    </g>
  </svg>
</template>

<script>
export default {
  data () {
    return {
      start: '',
      end: ''
    }
  },

  mounted () {
    const line = 2 * Math.PI * 43
    this.start = `0, ${line}`
    this.end = `${line}, 0`
  },

  methods: {
    play () {
      this.$refs.animate.beginElement && this.$refs.animate.beginElement()
    }
  }
}
</script>

<style lang="scss" scoped>
svg {
  transform: rotate(-90deg);
}
</style>
